import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { useGetAllCloudflareAccountsQuery } from '@/modules/DomainsApi';

interface Props {
  currentPage: number;
  cloudflareAccountsListItems: BaseQueryParams<typeof useGetAllCloudflareAccountsQuery>['data']['items'];
  cloudflareAccountsListTotalItems: BaseQueryParams<typeof useGetAllCloudflareAccountsQuery>['data']['meta']['totalItems'];
  cloudflareAccountsListItemsPerPage: BaseQueryParams<typeof useGetAllCloudflareAccountsQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const CloudflareAccountsListView: FC<Props> = ({
  currentPage,
  cloudflareAccountsListItems,
  cloudflareAccountsListTotalItems,
  cloudflareAccountsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const accountId = useParams()['*'];

  return (
    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: cloudflareAccountsListTotalItems,
        pageSize: cloudflareAccountsListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ accountId }
      rowKey="id"
      titleKey="email"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ ({ id }) => ({
        to: AppRoutes.DomainsApiCloudflareAccountsById.replace(':cloudflareAccountId', id)
      }) }
      list={ cloudflareAccountsListItems }
    />
  );
};
